import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IChatInput } from '../../interfaces/AppInterfaces';

const initialState: any = {
};

const chatsSlice = createSlice({
  name: 'chats',
  initialState,
  reducers: {
    setChat: (state, action: PayloadAction<{chatInput: IChatInput}>) => {
        const chatId = action.payload.chatInput.chat.chatId;
        if(state[chatId]) {
            state[chatId] = [...state[chatId], action.payload.chatInput];
        } else {
            state[chatId] = [action.payload.chatInput];
        } 
    },
    setChats: (state, action: PayloadAction<{chatInputs: IChatInput[]}>) => {
        action.payload.chatInputs.forEach((chatInput: IChatInput) => {
            const chatId = chatInput.chat.chatId
            if(state[chatId]) {
                state[chatId] = [...state[chatId], chatInput];
            } else {
                state[chatId] = [chatInput];
            }
            
        })
    },
  },
});

export const { setChat, setChats } = chatsSlice.actions;
export default chatsSlice.reducer;